// covered-by: frontends/carrie/src/ask-v2/transport/__tests__/AskV2ThreadComposerStack.test.tsx
import { type ReactNode } from "react";

import { AskV2ReviewEmailNotificationBanner } from "./AskV2ReviewEmailNotificationBanner";

import {
  ReviewInterventionBanner,
  type ReviewInterventionBannerProps,
} from "../../components/ReviewInterventionBanner";

type AskV2ThreadComposerStackProps = {
  chatId: string | null | undefined;
  reviewInProgress: boolean;
  /** A review blocked on the user; outranks the email opt-in above the composer. */
  intervention?: ReviewInterventionBannerProps | null;
  children: ReactNode;
};

export function AskV2ThreadComposerStack({
  chatId,
  reviewInProgress,
  intervention,
  children,
}: AskV2ThreadComposerStackProps) {
  return (
    <div
      className="flex w-full flex-col gap-2"
      data-testid="ask-v2-thread-composer-stack"
    >
      {intervention != null ? (
        <ReviewInterventionBanner {...intervention} />
      ) : null}
      {chatId ? (
        <AskV2ReviewEmailNotificationBanner
          chatId={chatId}
          reviewInProgress={reviewInProgress}
        />
      ) : null}
      {children}
    </div>
  );
}
